/* eslint react/prop-types: 0 */
import React from 'react'
import Select from 'react-select'
import {
  FormInput,
  FormInputText
} from 'camino-react'

const AttributesMatchCondition = ({
  predicates,
  update
}) => {
  const field = Object.keys(predicates)[0]
  const value = Object.values(predicates)[0]

  const handleField = (newField) => {
    const data = {}
    data[newField] = value

    update(null, data)
  }

  const handleValue = (newValue) => {
    const data = {}
    data[field] = newValue

    update(null, data)
  }

  const typeOptions = [
    { label: 'Email to', value: 'email_to' },
    { label: 'Email cc', value: 'email_cc' },
    { label: 'Email from', value: 'email_from' },
    { label: 'Email subject', value: 'email_subject' },
    { label: 'Email body', value: 'email_body' }
  ]

  return (
    <div>
      <FormInput label="Field">
        <Select
          options={typeOptions}
          value={field}
          onChange={e => handleField(e.value)}
        />
      </FormInput>

      <FormInput label="Text">
        <FormInputText
          value={value}
          onValue={e => handleValue(e)}
        />
      </FormInput>
    </div>
  )
}

export default AttributesMatchCondition
